import BaseFill, { IBaseFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/base';
import { IImageFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';

export interface IImageFillProperty extends IBaseFill {
    fillInfo: IImageFill;
}

export class ImageFillProperty extends BaseFill implements IImageFillProperty {
    declare public fillInfo: IImageFill;
    public constructor(fillInfo?: IImageFill) {
        super();
        if (fillInfo) {
            this.fillInfo = fillInfo;
        }
    }
}
